<!-- /* [NT-APPLY-COM-POP] 기업매칭신청 */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="매칭 신청하기"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <div class="popupViewProfileCardImage">
          <figure class="networkSearchItemImage">
            <img src="/images/manager/matching/demo1.png" alt="미국 국기" />
          </figure>
          <div class="popupViewProfileCardImageText">
            <h3
              style="color: #294A7A; font-size: 17px; font-weight: 400; margin-bottom: 4px;"
            >
              보낸 기업
            </h3>
            <h3 class="popupViewProfileCardImageTitle">
              (주)행복을 만드는 사람들
            </h3>
            <h5 class="popupViewProfileCardImageDesc">032-222-3333</h5>
            <h5 class="popupViewProfileCardImageEmail">asdfsadf@naver.com</h5>
            <MainButton
              btnText="홈페이지"
              customFontSize="16px"
              width="116px"
              customHeight="32px"
            />
          </div>
        </div>

        <h6
          class="popupViewProfileHeadline"
          style="padding-bottom: 0px !important;"
        >
          매칭 프로세스
        </h6>
        <section class="flex statusMatchingRow">
          <div
            class="statusMatchingItem"
            v-for="(item, index) in statusMatchingItems"
            :key="index"
            :style="{ backgroundColor: item.bgColor }"
          >
            <figure class="image">
              <img :src="item.img" :alt="item.title" />
            </figure>
            <div class="itemText">
              <div style="display: flex; justify-content: center;">
                <div class="itemTextIcon">
                  <figure>
                    <img :src="item.icon" :alt="item.title" />
                  </figure>
                  <h6>프로필 작성</h6>
                </div>
              </div>
              <h6 class="itemTextDesc">
                다른 기업들에게 보여질 소중한 기업정보를 입력해주세요.
              </h6>
            </div>
          </div>
        </section>

        <section>
          <h3 class="matchingHeadLine">신청서 작성</h3>
          <ValidationObserver
            tag="form"
            @submit.prevent="onClickSubmitForm"
            class="aRow5"
          >
            <div style="margin-bottom: 50px;">
              <ValidationProvider name="신청 대상 기업" rules="required">
                <InputField label="신청 대상 기업" v-model="form.test" />
              </ValidationProvider>
              <ValidationProvider name="매칭신청 사유" rules="required">
                <TextAreaInputField label="매칭신청 사유" v-model="form.test" />
              </ValidationProvider>

              <div class="line" style="margin-top: 20px;"></div>
              <h3 class="matchingHeadLine">
                연락처 정보
                <span style="color: #FF0000; font-size: 1.6rem;"
                  >*신청자가 다를 경우에는 수정하십시오.</span
                >
              </h3>
              <ValidationProvider name="신청자 이름" rules="required">
                <InputField label="신청자 이름" v-model="form.test" />
              </ValidationProvider>
              <ValidationProvider name="이메일 주소" rules="required">
                <InputField label="이메일 주소" v-model="form.test" />
              </ValidationProvider>
              <ValidationProvider name="전화번호" rules="required">
                <InputField label="전화번호" v-model="form.test" />
              </ValidationProvider>
            </div>
          </ValidationObserver>
        </section>
      </div>
      <template #footer>
        <router-link to="/corp/myMatchingStatusReceived"
          ><MainButton btnText="신청서 전송"
        /></router-link>
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import InputField from "@/components/formControl/InputField.vue";

export default {
  name: "NTApplyComPopup",
  components: {
    BasicModal,
    MainButton,
    ValidationObserver,
    ValidationProvider,
    TextAreaInputField,
    InputField,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
  },
  data() {
    return {
      form: {},
      statusMatchingItems: [
        {
          id: 1,
          title: "총 신청 수",
          number: "1423 건",
          img: "/images/myPage/matching1.svg",
          icon: "/images/myPage/docs.svg",
          bgColor: "#FFFDEE",
          textColor: "#26336A",
        },
        {
          id: 1,
          title: "매칭 대기",
          number: "123 건",
          img: "/images/myPage/matching2.svg",
          icon: "/images/myPage/search.svg",
          bgColor: "#FFFCDF",
          textColor: "#3F7416",
        },
        {
          id: 1,
          title: "매칭 완료",
          number: "1423 건",
          img: "/images/myPage/matching3.svg",
          icon: "/images/myPage/chat.svg",
          textColor: "#2B939A",
          bgColor: "#FFFACD",
        },
        {
          id: 1,
          title: "매칭 거절",
          number: "1423 건",
          img: "/images/myPage/matching4.svg",
          icon: "/images/myPage/hand.svg",
          textColor: "#BD4444",
          bgColor: "#FFF499",
        },
      ],
    };
  },
  methods: {
    onClickSubmitForm() {},
  },
};
</script>

<style lang="scss" scoped></style>
